<template>
  <div>
    <h4>New chat unblock</h4>
    <form @submit.prevent="unblock">
      <div class="form-group">
        <label for="reason">Reason</label>
        <textarea
          v-model="reason"
          id="reason"
          class="form-control"
          rows="3"
          maxlength="1024"
          required
        />
      </div>
      <b-button :to="{name: 'player_chat_block_log'}">Cancel</b-button>
      <b-button type="submit" variant="primary">
        Unblock chat
      </b-button>
    </form>
  </div>
</template>

<script>
import notifier from '../notifier';
import { HTTP } from '../http-common';

export default {
  name: 'PlayerChatUnblockAdd',

  props: {
    playerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      reason: '',
    };
  },

  methods: {
    unblock() {
      notifier.deleteSenderNotifications(this);

      const data = new FormData();
      data.append('reason', this.reason);

      const url = '/player/' + this.playerId + '/unblock_chat';
      HTTP.post(url, data)
      .then(() => {
        notifier.showSuccessAfterTransition('Chat unblocked.');
        this.$router.push({name: 'player_chat_block_log'});
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};
</script>
